import React from 'react'
import { Button } from 'components/Button/Button'
import { useTranslation } from 'react-i18next'
import { useValueBasedOnLanguage } from 'hooks/useValueBasedOnLanguage'

export interface Error404Props {
}

export const Error404: React.FC<Error404Props> = () => {
  const { t } = useTranslation('common')

  const link1 = useValueBasedOnLanguage(
    'https://medicare.gov',
    'https://es.medicare.gov/'
  )

  const link2 = useValueBasedOnLanguage(
    'https://www.medicare.gov/forms-help-resources/contact-medicare',
    'http://questions.medicare.gov/cgi-bin/medicare.cfg/php/enduser/std_alp.php'
  )

  const link3 = useValueBasedOnLanguage(
    'https://www.archive-it.org/collections/2650',
    'http://es.medicare.gov/forms-help-and-resources/contact/contact-medicare.html'
  )

  return (
    <main className='my-c-error ds-l-container'>
      <h1 id='maincontent' tabIndex={-1}>{t('errorPage.pageNotFound')}</h1>
      <p>{t('errorPage.para1')}</p>
      <ol>
        <li>{t('errorPage.li1')}</li>
        <li>{t('errorPage.li2')}</li>
        <li>{t('errorPage.li3')}</li>
      </ol>
      <p>{t('errorPage.para2')}</p>
      <ul>
        <li><Button href={link1}>{t('errorPage.link1')}</Button></li>
        <li><Button href={link2}>{t('errorPage.link2')}</Button></li>
        <li><Button href={link3}>{t('errorPage.link3')}</Button></li>
      </ul>
      <p><strong>{t('errorPage.para3bold')}</strong> {t('errorPage.para3')}</p>
    </main>
  )
}
